import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NoSsrModalGuard implements CanActivate {
  #platformId = inject(PLATFORM_ID);
  #router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Если мы на сервере и это модальный маршрут, перенаправляем на тот же URL без outlet
    if (isPlatformServer(this.#platformId) && route.outlet === 'modal') {
      // Получаем текущий URL и удаляем из него часть с модальным окном
      const currentUrl = state.url;
      const baseUrl = currentUrl.replace(/\(modal:[^)]+\)/, '');
      
      // Перенаправляем на базовый URL без модального окна
      return this.#router.parseUrl(baseUrl);
    }
    return true;
  }
}
